export default __webpack_public_path__ + "static/media/header-arrow.bfb41aaf.svg";